export default __webpack_public_path__ + "static/media/sf10.47c63a32.svg";